import React from 'react';

function parseInline(text) {
  const parts = [];
  let lastIndex = 0;
  const regex = /\*\*(.+?)\*\*/g;
  let match;
  while ((match = regex.exec(text)) !== null) {
    if (match.index > lastIndex) {
      parts.push(text.slice(lastIndex, match.index));
    }
    parts.push(<strong key={`b${match.index}`}>{match[1]}</strong>);
    lastIndex = regex.lastIndex;
  }
  if (lastIndex < text.length) {
    parts.push(text.slice(lastIndex));
  }
  return parts.length === 0 ? [text] : parts;
}

/**
 * Applies bold or quote formatting around the current selection in a textarea.
 * Returns the new text value and where to place the cursor.
 */
export function applyFormatting(textarea, type, setText) {
  const { selectionStart, selectionEnd, value } = textarea;
  const selected = value.slice(selectionStart, selectionEnd);

  let newValue, cursorPos;

  if (type === 'bold') {
    if (selected) {
      const before = value.slice(0, selectionStart);
      const after = value.slice(selectionEnd);
      newValue = `${before}**${selected}**${after}`;
      cursorPos = selectionEnd + 4;
    } else {
      const before = value.slice(0, selectionStart);
      const after = value.slice(selectionEnd);
      newValue = `${before}****${after}`;
      cursorPos = selectionStart + 2;
    }
  } else if (type === 'quote') {
    const lineStart = value.lastIndexOf('\n', selectionStart - 1) + 1;
    const lineEnd = value.indexOf('\n', selectionEnd);
    const end = lineEnd === -1 ? value.length : lineEnd;
    const lines = value.slice(lineStart, end).split('\n');
    const prefixed = lines.map(l => l.startsWith('> ') ? l : `> ${l}`).join('\n');
    const before = value.slice(0, lineStart);
    const after = value.slice(end);
    newValue = `${before}${prefixed}${after}`;
    cursorPos = lineStart + prefixed.length;
  }

  setText(newValue);
  requestAnimationFrame(() => {
    textarea.focus();
    textarea.selectionStart = textarea.selectionEnd = cursorPos;
  });
}

export function formatMessage(text) {
  if (!text) return text;

  const lines = text.split('\n');
  const groups = [];
  let current = { type: 'text', lines: [] };

  for (const line of lines) {
    const isQuote = line.startsWith('> ') || line === '>';
    const type = isQuote ? 'quote' : 'text';
    if (type !== current.type && current.lines.length > 0) {
      groups.push(current);
      current = { type, lines: [] };
    }
    current.type = type;
    current.lines.push(isQuote ? line.slice(2) : line);
  }
  if (current.lines.length > 0) groups.push(current);

  return groups.map((group, gi) => {
    const content = parseInline(group.lines.join('\n'));
    if (group.type === 'quote') {
      return (
        <blockquote
          key={gi}
          className="border-l-2 border-current/30 pl-2.5 opacity-75 my-1"
        >
          {content}
        </blockquote>
      );
    }
    return <React.Fragment key={gi}>{gi > 0 ? '\n' : ''}{content}</React.Fragment>;
  });
}
